/* global disableBodyScroll */
(function () {
    'use strict';

    angular
        .module('app')
        .factory('helpers', helpers);

    helpers.$inject = ['i18n',];

    function helpers(i18n) {
        var service = {
            lockScroll: lockScroll,
            unlockScroll: unlockScroll,
            getDatabaseDatetime: getDatabaseDatetime,
            generateString: generateString,
            generatePassword: generatePassword,
            generatePinCode: generatePinCode,
            handleErrorResponse: handleErrorResponse,
            handleDataValidationErrors: handleDataValidationErrors,
            validateEmail: validateEmail,
            printObject: printObject,
            idToLabel: idToLabel,
        };

        return service;

        function lockScroll(selector) {
            if (typeof disableBodyScroll === 'function') {
                disableBodyScroll(true, selector);
            }
            document.body.classList.add('lock-scroll');
            document.body.parentElement.classList.add('lock-scroll');
        }

        function unlockScroll(selector) {
            if (typeof disableBodyScroll === 'function') {
                disableBodyScroll(false, selector);
            }
            document.body.classList.remove('lock-scroll');
            document.body.parentElement.classList.remove('lock-scroll');
        }

        function getDatabaseDatetime(date) {
            var today = date ? date : new Date();
            var paddedSecond = today.getSeconds() < 10 ? '0' : '';
            var paddedMinute = today.getMinutes() < 10 ? '0' : '';
            var paddedHour = today.getHours() < 10 ? '0' : '';
            var paddedDay = today.getDate() < 10 ? '0' : '';
            var paddedMonth = today.getMonth() + 1 < 10 ? '0' : '';
            return today.getFullYear() + '-' + paddedMonth + (today.getMonth() + 1) + '-' + paddedDay + today.getDate() + ' ' + paddedHour + today.getHours() + ':' + paddedMinute + today.getMinutes() + ':' + paddedSecond + today.getSeconds();
        }

        function generateString(length, chars) {
            if (!length) {
                length = 6;
            }
            var generatedString = '';
            for (var x = 0; x < length; x++) {
                generatedString += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return generatedString;
        }

        function generatePassword(length) {
            if (!length) {
                length = 6;
            }
            var chars = 'abcdefghijklmnopqrstuvwxyz0123456789ABCEDFGIJKLMNOPQRSTUVXYZ';
            var generatedPassword = '';
            for (var x = 0; x < length; x++) {
                generatedPassword += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return generatedPassword;
        }

        function generatePinCode(length) {
            if (!length) {
                length = 4;
            }
            var chars = '0123456789';
            var generatedPassword = '';
            for (var x = 0; x < length; x++) {
                generatedPassword += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return generatedPassword;
        }

        function handleErrorResponse(response, override) {
            var errorCodes = {
                400: i18n.get('ERROR_BAD_REQUEST'),
                401: i18n.get('ERROR_UNAUTHORIZED'),
                403: i18n.get('ERROR_FORBIDDEN'),
                404: i18n.get('ERROR_NOT_FOUND'),
                405: i18n.get('ERROR_WRONG_METHOD_TYPE'),
                406: i18n.get('ERROR_NOT_ACCEPTABLE'),
                409: i18n.get('ERROR_CONFLICT'),
                422: i18n.get('ERROR_DATA_VALIDATION'),
                500: i18n.get('ERROR_SERVER_SHIT_ITSELF'),
                default: i18n.get('FAILED'),

            };
            var errorCode = errorCodes[response.status] ? errorCodes[response.status] : errorCodes.default;
            var errorMessage = response.config.method + ' ' + response.config.url + ' (' + response.status + '): <br>';
            if (!angular.equals(override, {})) {
                angular.extend(errorCodes, override);
            }
            if (typeof errorCode === 'string') {
                errorMessage += errorCode;
                window.toast({ message: errorMessage, type: 'danger' });
            } else {
                errorCode.then(function (translation) {
                    errorMessage += translation;
                    window.toast({ message: errorMessage, type: 'danger' });
                }, function () {

                });
            }

            handleDataValidationErrors(response);
        }

        function handleDataValidationErrors(response) {
            if (response.status === 422 && response.data.length) {
                var message = '';
                angular.forEach(response.data, function (error) {
                    message += error.message + '<br>';
                });
                window.toast({ message: message, type: 'danger' });
            }
        }

        function validateEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }

        function printObject(object, level) {
            if (!level) {
                // Start indentation
                level = 0;
            }

            var text = '';

            angular.forEach(object, function (value, key) {
                if (angular.isObject(value)) {
                    for (var a = 0; a < level; a++) {
                        text += '    ';
                    }
                    text += '"' + key + '": {\n';
                    text += printObject(value, level + 1);
                    for (var b = 0; b < level; b++) {
                        text += '    ';
                    }
                    text += '}\n';
                } else if (angular.isArray(value)) {
                    for (var c = 0; c < level; c++) {
                        text += '    ';
                    }
                    text += '"' + key + '": [\n';
                    text += printObject(value, level + 1);
                    for (var d = 0; d < level; d++) {
                        text += '    ';
                    }
                    text += ']\n';
                } else {
                    for (var e = 0; e < level; e++) {
                        text += '    ';
                    }
                    text += '"' + key + '": ';
                    if (typeof value === 'number') {
                        text += value;
                    } else if (typeof value === 'boolean') {
                        text += value ? 'true' : 'false';
                    } else if (typeof value === 'string') {
                        text += '"' + value + '"';
                    }
                    text += '\n';
                }
            });

            return text;
        }

        /**
         * Converts ID strings into a nicer label.
         *
         * Examples:
         * foo => Foo
         * foo-bar = Foo Bar
         * foo_bar = Foo Bar
         * foo bar = Foo Bar
         *
         * @param {string} id The id string.
         *
         * @return {string} The formatted string.
         */
        function idToLabel(id) {
            return id.split(/[\s-_]/)
                .join(' ')
                .replace(/^(.)|\s+(.)/g, function ($1) {
                    return $1.toUpperCase();
                });
        }
    }
})();